module.exports = __webpack_public_path__ + "img/image69.0424bc20.jpg";